function normalizeStatus(status) {
  var value = String(status || '').toLowerCase();
  if (value === 'ok' || value === 'warning' || value === 'error' || value === 'disabled') return value;
  return 'unknown';
}

function statusRank(status) {
  switch (normalizeStatus(status)) {
    case 'error': return 3;
    case 'warning': return 2;
    case 'ok': return 1;
    case 'disabled': return -1;
    default: return 0;
  }
}

function statusClass(status) {
  switch (normalizeStatus(status)) {
    case 'ok':
      return 'green';
    case 'warning':
      return 'yellow';
    case 'error':
      return 'red';
    case 'disabled':
      return 'moon-gray';
    default:
      return 'mid-gray';
  }
}

function isExplicitlyDisabled(record) {
  if (!record || typeof record.enabled === 'undefined' || record.enabled === null) return false;
  if (record.enabled === false || record.enabled === 0) return true;
  if (typeof record.enabled === 'string') {
    var normalized = record.enabled.trim().toLowerCase();
    return normalized === '0' || normalized === 'false' || normalized === 'no' || normalized === 'off';
  }
  return false;
}

function normalizeRid(rid) {
  if (typeof rid === 'undefined' || rid === null) return null;
  var value = String(rid).trim();
  return value || null;
}

function mergeStatus(currentStatus, nextStatus) {
  var normalizedNext = normalizeStatus(nextStatus);
  if (!currentStatus) return normalizedNext;
  return statusRank(normalizedNext) > statusRank(currentStatus)
    ? normalizedNext
    : normalizeStatus(currentStatus);
}

function indexByGatewayRid(workers) {
  var statusByRid = Object.create(null);

  (workers || []).forEach(function (worker) {
    var gateways = worker && Array.isArray(worker.gateways) ? worker.gateways : [];
    gateways.forEach(function (gateway) {
      var gatewayInfo = gateway && gateway.gateway ? gateway.gateway : null;
      var rid = normalizeRid(gatewayInfo && gatewayInfo['@rid']);
      if (!rid) return;
      statusByRid[rid] = mergeStatus(statusByRid[rid], gateway && gateway.status);
    });
  });

  return statusByRid;
}

function statusForRecord(record, statusByRid) {
  if (isExplicitlyDisabled(record)) return 'disabled';
  var rid = normalizeRid(record && record['@rid']);
  if (!rid || !statusByRid) return 'unknown';
  return normalizeStatus(statusByRid[rid]);
}

module.exports = {
  indexByGatewayRid: indexByGatewayRid,
  isExplicitlyDisabled: isExplicitlyDisabled,
  normalizeStatus: normalizeStatus,
  statusClass: statusClass,
  statusForRecord: statusForRecord,
  statusRank: statusRank
};
